import { useAppNavigate } from "hooks/useAppNavigate";
import React from "react";
import Box from "@mui/material/Box";
import Typography from "@mui/material/Typography";
import { alpha } from "@mui/material/styles";
import LoadingButton from "components/LoadingButton";
import Card from "components/Card";
import PageMeta from "components/PageMeta";
import { useLoginPage } from "hooks/useLoginPage";
import { useText } from "context/TextProvider";

const DeviceGrantPasswordResetSuccess = (): JSX.Element => {
  const text = useText();
  const appNavigate = useAppNavigate();
  const { configId } = useLoginPage();

  React.useEffect(() => {
    const timer = setTimeout(() => {
      appNavigate(`/device-grant-flow/login`);
    }, 3000);
    return () => clearTimeout(timer);
  }, [appNavigate, configId]);

  return (
    <>
      <PageMeta name="Device Grant Password Reset Success" />
      {/* Glassmorphism Card */}
      <Box className="animate-fadein" sx={{ flex: 1, display: "flex", alignItems: "center", justifyContent: "center" }}>
        <Card>
          {/* Animated Checkmark */}
          <Box sx={{ display: "flex", justifyContent: "center", mb: "1.5rem" }}>
            <Box
              component="svg"
              className="animate-pop"
              sx={{ width: "5rem", height: "5rem", color: "success.main" }}
              fill="none"
              viewBox="0 0 80 80"
              stroke="currentColor"
            >
              <circle cx="40" cy="40" r="36" stroke="currentColor" strokeWidth="4" opacity="0.2" />
              <path d="M25 42l12 12 18-22" stroke="currentColor" strokeWidth="5" strokeLinecap="round" strokeLinejoin="round"/>
            </Box>
          </Box>
          <Typography component="h2" sx={(theme) => ({ mb: "0.5rem", textAlign: "center", fontSize: "1.875rem", fontWeight: 700, filter: `drop-shadow(0 1px 2px ${alpha(theme.palette.common.black, 0.1)})` })}>{text.deviceGrant.passwordResetSuccess.title}</Typography>
          <Typography component="p" sx={{ fontSize: "1.125rem", color: "text.primary", mb: "2rem", textAlign: "center" }}>{text.deviceGrant.passwordResetSuccess.messageLine1}<br/>{text.deviceGrant.passwordResetSuccess.messageLine2}</Typography>
          <LoadingButton
            loading={false}
            onClick={() => appNavigate(`/device-grant-flow/login`)}
            sx={{
              width: "100%",
              height: "3.5rem",
              mb: "1rem",
            }}
          >
            {text.deviceGrant.passwordResetSuccess.goToLoginButton}
          </LoadingButton>
          <Typography component="div" sx={{ mt: "0.5rem", textAlign: "center", fontSize: "0.875rem", color: "text.secondary", fontWeight: 500 }}>{text.deviceGrant.passwordResetSuccess.redirecting}</Typography>
        </Card>
      </Box>
      {/* Animations */}
      <style>{`
        .animate-fadein { animation: fadein 0.7s; }
        @keyframes fadein { from { opacity: 0; transform: translateY(30px);} to { opacity: 1; transform: none; } }
        .animate-pop { animation: pop 0.5s cubic-bezier(.68,-0.55,.27,1.55); }
        @keyframes pop { 0% { transform: scale(0.5); opacity: 0; } 80% { transform: scale(1.1); opacity: 1; } 100% { transform: scale(1); } }
      `}</style>
    </>
  );
};

export default DeviceGrantPasswordResetSuccess;
